import React from 'react'
import { Form, Col, DropdownButton, Dropdown, InputGroup, Spinner, Modal, Button } from 'react-bootstrap'

// components
import { Search } from 'react-feather'

// definitions
import { AccountXeroOrgWithData } from '../../../../screens/subsync/subsync'
import { XeroAPIContact } from '../../../../../../back-end/utilities/apiDefinitions'
import { MessageAction } from '../../../ui/messages/message'
import { AppState } from '../../../../App.d'

// utilities
import * as Request from '../../../../utilities/request'

interface XeroContactLiveSearchProps {
	onConfirm: (values: { xeroContactID: string; xeroContact: XeroAPIContact | undefined }) => void
	accountXeroOrg: AccountXeroOrgWithData
	appState: AppState
	disabled?: boolean
	updateMessages: (action: MessageAction) => void
}

const XeroContactLiveSearch = (props: XeroContactLiveSearchProps) => {
	const [showModal, setShowModal] = React.useState<boolean>(false)
	const [xeroContactSearch, setXeroContactSearch] = React.useState<string>('')
	const [isSearching, setIsSearching] = React.useState<boolean>(false)
	const [xeroContacts, setXeroContacts] = React.useState<XeroAPIContact[]>([])
	const [selectedXeroContactID, setSelectedXeroContactID] = React.useState<string>('')

	const handleXeroContactSearch = async () => {
		setIsSearching(true)
		try {
			const body = {
				userAccountXeroOrgAuthID: props.accountXeroOrg?.userAccountXeroOrgAuth?.id,
				tenantID: props.accountXeroOrg?.xeroOrg?.tenantID,
				xeroOrgID: props.accountXeroOrg?.xeroOrg?.xeroOrgID,
				contactName: xeroContactSearch,
			}
			const res = await Request.post('xerocontact/search', body, props.appState.authState)
			setXeroContacts(res.data.data)
		} catch (e) {
			props.updateMessages({
				type: 'add',
				data: {
					severity: 'danger',
					message: 'Unable to search Xero contacts',
					timeout: 3000,
					dismissible: true,
				},
			})
		} finally {
			setIsSearching(false)
		}
	}
	return (
		<>
			{!props.disabled && (
				<Col>
					<Button variant="secondary" onClick={() => setShowModal(true)}>
						{selectedXeroContactID ? 'Change Xero contact' : 'Search Xero Contacts'}
					</Button>
				</Col>
			)}
			<Modal show={showModal} onHide={() => setShowModal(false)} size="lg">
				<Modal.Header closeButton>
					<Modal.Title>Search Xero Contacts</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<Form.Group>
						<Col className="mb-3">
							<InputGroup>
								<Form.Control
									placeholder="Search Xero contacts"
									value={xeroContactSearch}
									onChange={(e) => setXeroContactSearch(e.target.value)}
								/>
								<InputGroup.Text>
									{isSearching ? (
										<Spinner animation={'border'} size={'sm'} />
									) : (
										<Search className="clickable-icon" onClick={() => handleXeroContactSearch()} />
									)}
								</InputGroup.Text>
							</InputGroup>
						</Col>
						<Col>
							<DropdownButton
								id={`xero-contact-live-search-select`}
								title={xeroContacts.find((c) => c.contactID === selectedXeroContactID)?.name || xeroContacts[0]?.name || 'Select Xero Contact'}
								onSelect={(eventKey) => {
									setSelectedXeroContactID(eventKey!)
								}}
							>
								{xeroContacts.map((contact) => (
									<Dropdown.Item key={contact.contactID} eventKey={contact.contactID}>
										{contact.name}
									</Dropdown.Item>
								))}
							</DropdownButton>
						</Col>
					</Form.Group>
				</Modal.Body>
				<Modal.Footer>
					<Button
						variant="secondary"
						onClick={() => {
							setSelectedXeroContactID('')
							setXeroContactSearch('')
							setShowModal(false)
						}}
					>
						Cancel
					</Button>
					<Button
						variant="primary"
						onClick={() => {
							setShowModal(false)
							props.onConfirm({
								xeroContactID: selectedXeroContactID,
								xeroContact: xeroContacts.find((c) => c.contactID === selectedXeroContactID),
							})
						}}
						disabled={!selectedXeroContactID}
					>
						Confirm
					</Button>
				</Modal.Footer>
			</Modal>
		</>
	)
}

export { XeroContactLiveSearch }
